import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "./index.css";
import { CiCircleMinus } from "react-icons/ci";
import { Col, Stack } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setdetailReportActionData } from "../../../../redux/slice/DetailReportSummarySlice";
import IconButton from "../../../../components/Common/Button/IconButton";
import ProductTableView from "../common/ProductTableView";
import { fetchUsers } from "../../../../redux/slice/QuickReportSlice";
import SelectWithTextfield from "../../../../components/Common/MUI/SelectWithTextfield";

const outcomeOptions = [
  "Returned to work?",
  "Was the person sent home?",
  "Was an ambulance called?",
  "Was the person taken to the hospital?",
  "Other",
];

const DetailedReportTakeAction = () => {
  const [category_classficationdata, setCategory_classficationdata] = useState({
    category: [],
    classfication: [],
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { detailReportActionData } = useSelector((state) => state.DetailReport);
  const {
    category_classfication_data,
    injuryType,
    usersList,
    quichReportData,
  } = useSelector((state) => state.QUICKREPORT);

  // main state
  const [formData, setFormData] = useState(detailReportActionData);
  const [isOutcomeOther, setIsOutcomeOther] = useState(false);
  const [users, setUsers] = useState([]);
  // form data on change function
  const onChange = (event) => {
    const { name, value } = event.target;
    if (name === "injuryClassification") {
      const filterarray = category_classfication_data?.data?.Incidents?.find(
        (curElm) => curElm.name === value
      );
      setCategory_classficationdata({
        ...category_classficationdata,
        classfication: filterarray?.description,
      });
    }
    if (name === "incidentOutcome") {
      if (event.target.type === "select-one") {
        if (value === outcomeOptions[outcomeOptions.length - 1]) {
          setIsOutcomeOther(true);
        } else {
          setIsOutcomeOther(false);
          setFormData((prev) => {
            const dataItem = {
              ...prev,
              incidentOutcomeOther: { value: "", warning: false },
            };
            return dataItem;
          });
        }
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: { value: value, warning: !value ? true : false },
    }));
  };

  // validateform
  const validateForm = (event) => {
    event.preventDefault();
    let data = { ...formData };
    data = {
      ...data,
      personOfTreatment: {
        ...data.personOfTreatment,
        warning: !data.personOfTreatment.value,
      },
      injuryClassification: {
        ...data.injuryClassification,
        warning: !data.injuryClassification.value,
      },
      injuryType: { ...data.injuryType, warning: !data.injuryType.value },
    };
    setFormData({ ...data });
    if (
      !data.personOfTreatment.warning &&
      !data.injuryClassification.warning &&
      !data.injuryType.warning
    ) {
      let dataArr = [...formData.formArr];
      dataArr.push(data);
      setFormData((prev) => {
        const dataItem = {
          ...prev,
          formArr: dataArr,
          personOfTreatment: { value: "", warning: false },
          injuryClassification: { value: "", warning: false },
          injuryType: { value: "", warning: false },
          injuryDetail: { value: "", warning: false },
          incidentOutcome: { value: "", warning: false },
          incidentOutcomeOther: { value: "", warning: false },
          otherDetail: { value: "", warning: false },
        };
        setIsOutcomeOther(false);
        dispatch(setdetailReportActionData(dataItem));
        return dataItem;
      });
    }
  };

  const validateFormSingle = (event) => {
    event.preventDefault();
    let data = { ...formData };
    data = {
      ...data,
      personOfTreatment: {
        ...data.personOfTreatment,
        warning: !data.personOfTreatment.value,
      },
      injuryClassification: {
        ...data.injuryClassification,
        warning: !data.injuryClassification.value,
      },
      injuryType: { ...data.injuryType, warning: !data.injuryType.value },
    };
    setFormData({ ...data });
    if (
      !data.personOfTreatment.warning &&
      !data.injuryClassification.warning &&
      !data.injuryType.warning
    ) {
      setFormData((prev) => {
        const dataItem = {
          ...prev,
          formArr: [data],
        };
        setIsOutcomeOther(false);
        dispatch(setdetailReportActionData(dataItem));
        navigate("/detailedreporforfilleditem");
        return dataItem;
      });
    }
  };

  useEffect(() => {
    const data = {
      category: category_classfication_data?.data?.Incidents?.map(
        (itemIncdients) => {
          return itemIncdients.name;
        }
      ),
      classfication:
        category_classfication_data?.data?.Incidents?.[0]?.description.map(
          (element) => {
            return element;
          }
        ),
    };
    setCategory_classficationdata(data);
  }, [category_classfication_data?.data?.Incidents]);

  const handleRemove = (index) => {
    const data = [...formData?.formArr];
    data.splice(index, 1);
    setFormData((prev) => {
      const dataItem = { ...prev, formArr: data };
      dispatch(setdetailReportActionData(dataItem));
      return dataItem;
    });
  };

  const getTableBody = (data) => {
    const tableBody =
      data?.length > 0
        ? data?.map((item, index) => {
            return {
              cell: [
                {
                  data: (
                    <h6 className="mb-0">{item?.personOfTreatment?.value}</h6>
                  ),
                  align: "start",
                },
                {
                  data: (
                    <Stack
                      direction="horizontal"
                      className="gap-3 justify-content-between"
                    >
                      <h6 className="mb-0" style={{ minWidth: "150px" }}>
                        {item?.injuryType?.value}
                      </h6>
                      <IconButton
                        size="xxs"
                        onClick={() => handleRemove(index)}
                      >
                        <CiCircleMinus
                          size={36}
                          color="rgba(23, 23, 23, 0.5)"
                        />
                      </IconButton>
                    </Stack>
                  ),
                  align: "center",
                },
              ],
            };
          })
        : [];
    return tableBody;
  };

  useEffect(() => {
    dispatch(fetchUsers(quichReportData?.kit_data?.company_id));
  }, []);

  useEffect(() => {
    const formattedList = usersList.map((user) => {
      return `${user.first_name} ${user.last_name}`;
    });
    setUsers(formattedList);
  }, [usersList]);

  const groupedData = formData?.formArr?.reduce((acc, item) => {
    const personName = item?.personOfTreatment?.value;
    if (!acc[personName]) {
      acc[personName] = []; // Initialize an empty array if this person doesn't exist in the accumulator
    }
    acc[personName].push(item); // Add the item to the corresponding person array
    return acc;
  }, {});

  const result = Object.keys(groupedData).map((key) => ({
    name: key,
    array: groupedData[key],
  }));

  return (
    <Form className="detailedreporttakeAction flex-grow-1 d-flex flex-column justify-content-between">
      <div className="incident-report-container">
        <h6 className="mb-3 fw-bold text-center">
          Who was injured and what action taken?
        </h6>
        <Stack className="row-gap-3">
          <div>
            <SelectWithTextfield
              value={formData.personOfTreatment.value ?? ""}
              onValueChange={(value) =>
                setFormData((prev) => ({
                  ...prev,
                  personOfTreatment: {
                    value,
                    warning: !value ? true : false,
                  },
                }))
              }
              textProps={{
                placeholder: "Person of treatment",
                variant: "outlined",
                name: "personOfTreatment",
              }}
              autoCompleteProps={{ disableClearable: true }}
              options={users ?? []}
            />
            {formData.personOfTreatment.warning && (
              <p className="text-danger mt-1 mb-0">
                Select or Type person of treatment
              </p>
            )}
          </div>
          <Form.Group controlId="formBasicEmail">
            <Form.Select
              aria-label="Default select example"
              className="custom-select-box"
              value={formData.injuryClassification.value}
              name={"injuryClassification"}
              onChange={onChange}
            >
              <option value="" disabled className="option-title">
                Injury Classification
              </option>
              {category_classficationdata?.category?.map(
                (categoryItem, index) => (
                  <option value={categoryItem} key={index}>
                    {categoryItem}
                  </option>
                )
              )}
            </Form.Select>
            {formData.injuryClassification.warning && (
              <p className="text-danger mt-1 mb-0">Select the Classification</p>
            )}
          </Form.Group>
          <Form.Group controlId="formBasicEmail">
            <Form.Select
              aria-label="Default select example"
              className="custom-select-box"
              value={formData.injuryType.value}
              name={"injuryType"}
              onChange={onChange}
            >
              <option value="" disabled className="option-title">
                Injury type
              </option>
              {category_classficationdata?.classfication?.map(
                (descriptionItem, index) => (
                  <option value={descriptionItem} key={index}>
                    {descriptionItem}
                  </option>
                )
              )}
            </Form.Select>
            {formData.injuryType.warning && (
              <p className="text-danger mt-1 mb-0">Select the Injury type</p>
            )}
          </Form.Group>
          <Form.Group controlId="formBasicEmail">
            <Form.Control
              type="text"
              placeholder="Injury detail"
              value={formData.injuryDetail.value}
              name={"injuryDetail"}
              onChange={onChange}
            />
            {formData.injuryDetail.warning && (
              <p className="text-danger mt-1 mb-0">Enter the injuryDetail</p>
            )}
          </Form.Group>
          <Form.Group controlId="formBasicEmail">
            <Form.Select
              aria-label="Default select example"
              className="custom-select-box"
              value={formData.incidentOutcome.value}
              name={"incidentOutcome"}
              onChange={onChange}
            >
              <option value="" disabled className="option-title">
                Incident Outcome
              </option>
              {outcomeOptions.map((descriptionItem, index) => (
                <option value={descriptionItem} key={index}>
                  {descriptionItem}
                </option>
              ))}
            </Form.Select>
            {formData.incidentOutcome.warning && (
              <p className="text-danger mt-1 mb-0">
                Select the incident outcome
              </p>
            )}
          </Form.Group>
          {isOutcomeOther && (
            <Form.Group controlId="formBasicItem">
              <Form.Control
                as="textarea"
                placeholder="Enter incident outcome"
                style={{ height: "150px" }}
                value={formData.incidentOutcomeOther.value}
                name={"incidentOutcomeOther"}
                onChange={onChange}
              />
            </Form.Group>
          )}
          <Form.Group controlId="formBasicEmail">
            <Form.Control
              type="text"
              placeholder="If Other, provide details"
              value={formData.otherDetail.value}
              name={"otherDetail"}
              onChange={onChange}
            />
          </Form.Group>
          {injuryType === "multiple" && (
            <Col>
              <Button
                variant="dark"
                className="w-100 p-3 fw-bold letter_spacing"
                onClick={validateForm}
              >
                {formData?.formArr?.length > 0
                  ? "Add Another Person"
                  : "Add Person"}
              </Button>
            </Col>
          )}
          {injuryType === "multiple" && (
            <>
              {result.map((item, index) => {
                return (
                  <ProductTableView
                    key={index} // Add key to avoid warnings in React
                    tableHeader={[
                      { name: `Used by ${item.name}`, align: "left" },
                      { name: "Injury type", align: "center" },
                    ]}
                    tableBody={getTableBody(item.array)}
                  />
                );
              })}
            </>
          )}
        </Stack>
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink to="/detailedreportsummary" className="nav-link">
          <Button variant="dark fw-bold h-100">Cancel</Button>
        </NavLink>
        <div>
          {injuryType === "single" ? (
            <Button
              variant="primary"
              className="button_custom fw-bold text-black"
              onClick={(e) => {
                validateFormSingle(e);
              }}
            >
              Continue
            </Button>
          ) : (
            <Button
              variant="primary"
              className="button_custom fw-bold text-black"
              disabled={formData.formArr.length === 0 ? true : false}
              onClick={() => {
                navigate("/detailedreporforfilleditem");
              }}
            >
              Continue
            </Button>
          )}
        </div>
      </div>
    </Form>
  );
};

export default DetailedReportTakeAction;
